import CloudUpload from '@/components/editor/plugins/cloud-upload';
import property from '@/configs/editor';

import { qiniuInfo as getCloudsToken } from '@/api/common';

export default {
  data() {
    return {
      config: {},
      upload: {
        domain: 'https://upload-z2.qiniup.com',
        url: '',
        filename: 'file',
      },
    };
  },

  created() {
    this.getEditorCloudsToken();

    this.config = Object.assign({}, property, {
      plugins: [CloudUpload],
      toolbar: property.toolbar.concat(['CloudUpload'], ['|', 'undo', 'redo']),
      upload: {
        config: this.handleUploadConfig,
        handle: this.handlerImageUpload,
      },
    });
  },

  methods: {
    handleUploadConfig() {
      return this.upload;
    },

    handlerImageUpload(data) {
      return `${this.upload.url}${data.hash}`;
    },

    handlerEditorError(error) {
      /* eslint-disable */
      console.log('====================================');
      console.log(error);
      console.log('====================================');
      /* eslint-disable */
    },

    async getEditorCloudsToken() {
      const { data } = await getCloudsToken();

      this.upload = Object.assign(this.upload, {
        url: data.BucketDomain,
        data: {
          token: data.token,
        },
      });
    },
  },
};
